import { LitEntity, SirenActionMixin, html } from '../../utility/lit-entity';
import '../../common/bn-icon';
import './devices-total-count';

class DevicesTotalCountByFlag extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      maxcount: { type: Number },
      flagname: { type: String },
      filteredHref: { type: String, attribute: false },
    };
  }

  render() {
    if (!this.entity) {
      return html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>`;
    }
    return html`<devices-total-count .href="${this.filteredHref}" maxcount=${this.maxcount}></devices-total-count>`;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    if (this.filteredHref) {
      return;
    }

    const action = this.entity.getActionByName('filter-by-flag');
    const fields = this.getActionFields(action);
    fields.set('flag', this.flagname);
    fields.set('flagVisibility', 'visible');
    this.filteredHref = this.parseAction(action, fields).url.href;
  }
}

window.customElements.define('devices-total-count-by-flag', DevicesTotalCountByFlag);
